/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type CalloutContent = {
  title: string;
  description: string;
  buttonText: string;
  resultType: ResultType;
  buttonUrl: string;
  listingId?: number;
  collectionEntityId?: number;
  imageUrl?: string;
  videoId?: number;
  iconUrl?: string;
  entityVersionId: number;
  audience: Audience;
  linguineTranslationUid?: string;
  updatedAt: number;
  updatedBy: string;
};

export type Audience = 'ALL' | 'IN_APP' | 'PUBLIC' | unhandledEnumCase;

export type PublishState =
  | 'DRAFT_WITHOUT_PLACEMENT'
  | 'DRAFT'
  | 'PUBLISHED'
  | 'PUBLISHED_WITH_CHANGES'
  | 'SCHEDULED'
  | 'ARCHIVED'
  | unhandledEnumCase;

export type ResultType =
  | 'LISTING'
  | 'COLLECTION'
  | 'EXTERNAL_LINK'
  | 'INTERNAL_LINK'
  | unhandledEnumCase;

export type DiscoveryStudioError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'CALLOUT_NOT_FOUND'
  | 'COLLECTION_NOT_FOUND'
  | 'COLLECTION_REFERENCED_BY_CALLOUT'
  | 'INVALID_ENTITY'
  | 'ENTITY_ARCHIVED'
  | 'PLACEMENT_CONFLICT'
  | 'SLUG_CONFLICT'
  | 'SUBMISSION_ALREADY_EXECUTED'
  | 'INVALID_IMAGE'
  | 'IMAGE_UPLOAD_FAILED'
  | 'PUBLISH_LIMIT_EXCEEDED'
  | unhandledEnumCase;

export const CalloutPlacementTypename =
  'com.hubspot.marketplace.discovery.studio.models.placements.CalloutPlacement';
export const CalloutPlacementDiscriminant = 'CALLOUT';
export const CalloutPlacementDiscriminantKey = 'entityType';
export type CalloutPlacement = {
  calloutContent: CalloutContent;
  page: string;
  section: string;
  entityId: number;
  name: string;
  publishState: PublishState;
  scheduledPublishAt?: number;
  contentChanged: Default<boolean>;
  __typename: 'com.hubspot.marketplace.discovery.studio.models.placements.CalloutPlacement';
} & { entityType?: 'CALLOUT' };

export const CollectionPlacementTypename =
  'com.hubspot.marketplace.discovery.studio.models.placements.CollectionPlacement';
export const CollectionPlacementDiscriminant = 'COLLECTION';
export const CollectionPlacementDiscriminantKey = 'entityType';
export type CollectionPlacement = {
  collectionPreview: CollectionPreview;
  page: string;
  section: string;
  entityId: number;
  name: string;
  publishState: PublishState;
  scheduledPublishAt?: number;
  contentChanged: Default<boolean>;
  __typename: 'com.hubspot.marketplace.discovery.studio.models.placements.CollectionPlacement';
} & { entityType?: 'COLLECTION' };

export type CollectionPreview = {
  entityId: number;
  name: string;
  slug: string;
  title?: string;
  description?: string;
  audience: Audience;
  previewItems: Default<ListingCardPreview[]>;
  listingCount: number;
};

export type GetPlacementsRequest = { page?: string; published: boolean };

export type GetPlacementsResponse = {
  placements: Default<Placement[]>;
  total: number;
};

export type ListingCardPreview = {
  listingId: number;
  name: string;
  slug: string;
  iconUrl: string;
  description: string;
  productTypes: Default<ProductType[]>;
};

export const PlacementDiscriminantKey = 'entityType';
export type Placement = CalloutPlacement | CollectionPlacement;

export type ProductType =
  | 'APP'
  | 'THEME'
  | 'MODULE'
  | 'AGENT'
  | 'SOLUTIONS_PARTNER_PROFILE'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type GetPlacementsRequestType = Requestify<GetPlacementsRequest>;
export type GetPlacementsResponseType = GetPlacementsResponse;
export type GetPlacementsErrorType = DiscoveryStudioError & HubspotMetadata;
export const getPlacementsRpc: ChirpAvroRpcDetails<
  GetPlacementsRequestType,
  GetPlacementsResponseType,
  GetPlacementsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc',
  rpcName: 'getPlacements',
  auth: 'external',
  fingerprint: 'XvdgxacOVTxdehBbrhu9h53WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
